/* Set composition is supplied by set-components.liquid; drawing and rules are shared. */
(() => {
  'use strict';
  const NB = window.NB;
  // Pure order builder is exercised offline and keeps the form and cart contract together.
  NB.sets = {
    variant(variants,colour,count) {
      return variants.find(v => v.options[count ? 1 : 0] === colour && (!count || parseInt(v.options[0],10) === count));
    },
    item({variant,quantity,fields,fontId,colour,message,available,error}) {
      const font = NB.util.fontById(fontId);
      if (!available || !variant?.available || !Number.isInteger(quantity) || quantity < 1
          || !fields.length || !fields.every(field => NB.util.validName(field.value)
            && (!font.upper || field.value === field.value.toUpperCase()))
          || Array.from(message).length > 40) throw new Error(error);
      const properties = Object.fromEntries(fields.map(field => [field.key,field.value]));
      properties['書体'] = font.orderLabel;properties['_書体ID'] = font.id + '-' + font.family;
      properties['カラー'] = colour;properties['_Spelling confirmed'] = 'yes';
      if (message) {properties['メッセージ'] = message;properties['メッセージ印刷'] = 'セット特典（無料）';}
      return {id:variant.id,quantity,properties};
    }
  };
  function init(root) {
    if (root.__setProduct || !root.querySelector('[data-set-data]')) return;
    root.__setProduct = true;
    const q = selector => root.querySelector(selector);
    const data = JSON.parse(q('[data-set-data]').textContent), form = q('form');
    const colour = q('[data-set-colour]'), count = q('[data-set-count]'), fontSelect = q('[data-set-font]');
    const modal = q('[data-set-confirm]'), consent = q('[data-set-consent]'), add = q('[data-set-add]'), review = q('[data-set-review]');
    const abort = new AbortController();
    const on = (node,event,handler) => node.addEventListener(event,handler,{signal:abort.signal});
    const initial = data.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) || data.variants.find(v => v.id === data.selected) || data.variants[0];
    const colorIndex = count ? 1 : 0;
    [...new Set(data.variants.map(v => v.options[colorIndex]))].forEach(value => {
      const key = NB.shopify.colorKey(value);
      const option = new Option(NB.config.colors[key]?.label || value,value);
      option.style.background = NB.config.colors[key]?.swatch || ''; colour.add(option);
    });
    colour.value = initial.options[colorIndex];
    const swatches = document.createElement('div');
    swatches.className = 'merged-colors';swatches.setAttribute('role','group');
    swatches.setAttribute('aria-label',colour.labels[0].textContent);
    [...colour.options].forEach(option => {
      const key = NB.shopify.colorKey(option.value), label = document.createElement('label');
      const radio = document.createElement('input'), chip = document.createElement('span'), caption = document.createElement('span');
      radio.type = 'radio';radio.name = 'set-colour-choice';radio.value = option.value;radio.dataset.setColourChip = '';
      chip.className = 'set-colour-swatch';chip.style.background = NB.config.colors[key]?.swatch || '';
      caption.textContent = option.textContent;label.append(radio,chip,caption);swatches.append(label);
      ['input','change'].forEach(type => on(radio,type,() => {if (radio.checked) colour.value = radio.value;}));
    });
    colour.after(swatches);colour.hidden = true;
    if (count) count.value = String(parseInt(initial.options[0],10));
    NB.util.latinFonts().forEach(font => fontSelect.add(new Option(font.label,font.id)));
    fontSelect.value = NB.config.defaults.font;
    const components = [...root.querySelectorAll('[data-set-component]')].map(node => ({
      node, inputs:[...node.querySelectorAll('[data-set-name]')],
      preview:NB.createProductPreview(node.querySelector('svg'),{shine:false})
    }));
    let variant, snapshot = null, revision = 0, busy = false, fontReady = false, generation = 0;
    const showError = (node,message) => {node.textContent = message || '';node.hidden = !message;};
    const activeInputs = () => components.flatMap(c => c.inputs.filter(input => !input.disabled));
    function syncAdd() {add.disabled = busy || !snapshot || !consent.checked || !fontReady || snapshot.revision !== revision;}
    function close() {modal.close();snapshot = null;consent.checked = false;syncAdd();review.focus();}
    function render() {
      revision++; snapshot = null;consent.checked = false;syncAdd();
      if (modal.open && !busy) close();
      variant = NB.sets.variant(data.variants,colour.value,count ? Number(count.value) : null);
      swatches.querySelectorAll('input').forEach(input => {input.checked = input.value === colour.value;});
      q('[data-set-id]').value = variant?.id || '';
      q('[data-set-price]').textContent = variant?.money || '—';
      review.disabled = busy || !data.available || !variant?.available;
      const selectedFont = NB.util.fontById(fontSelect.value), color = NB.shopify.colorKey(colour.value);
      components.forEach(c => {
        c.inputs.forEach((input,i) => {
          const visible = c.node.dataset.setComponent !== 'family' || i < Number(count.value);
          input.disabled = !visible; input.required = visible; input.closest('[data-set-name-row]').hidden = !visible;
          input.setCustomValidity('');
        });
        c.preview.render({names:c.inputs.filter(input => !input.disabled).map(input => input.value),count:c.inputs.filter(input => !input.disabled).length,font:selectedFont.id,color});
      });
      q('[data-set-counter]').textContent = `${Array.from(q('[data-set-message]').value).length} / 40`;
    }
    on(form,'input',render);on(form,'change',render);
    on(form,'submit',async event => {
      event.preventDefault(); if (busy) return;
      showError(q('[data-set-error]'),'');
      const inputs = activeInputs(), font = NB.util.fontById(fontSelect.value);
      inputs.forEach(input => input.setCustomValidity(NB.util.validName(input.value) && (!font.upper || input.value === input.value.toUpperCase()) ? '' : data.text.error));
      if (!form.reportValidity() || !variant?.available || !data.available) return;
      const message = q('[data-set-message]').value.trim();
      if (Array.from(message).length > 40) {showError(q('[data-set-error]'),data.text.message_required);return;}
      try {
        snapshot = {revision,item:NB.sets.item({variant,quantity:Number(form.elements.quantity.value),
          fields:inputs.map(input => ({key:input.dataset.property,value:input.value})),fontId:font.id,
          colour:colour.value,message,available:data.available,error:data.text.error})};
      } catch (failure) {showError(q('[data-set-error]'),failure.message);return;}
      q('[data-set-summary]').replaceChildren();
      // Confirmation uses labels already translated by the component form.
      inputs.forEach(input => {
        const dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = input.closest('fieldset').querySelector('legend').textContent + ' · ' + input.labels[0].textContent;
        dd.textContent = input.value;q('[data-set-summary]').append(dt,dd);
      });
      [colour.selectedOptions[0].textContent,font.label,variant.money,message].filter(Boolean).forEach(value => {const dd = document.createElement('dd');dd.textContent=value;q('[data-set-summary]').append(dd);});
      showError(q('[data-set-confirm-error]'),'');consent.checked = false;fontReady = false;syncAdd();modal.showModal();
      const request = ++generation;
      const ok = await NB.fonts.ensure(font);
      if (request !== generation || !modal.open || !snapshot) return;
      fontReady = ok;showError(q('[data-set-confirm-error]'),ok ? '' : data.text.font_error);syncAdd();
    });
    on(consent,'change',syncAdd);on(q('[data-set-edit]'),'click',close);
    on(modal,'cancel',event => {event.preventDefault();if (!busy) close();});
    on(add,'click',async () => {
      if (busy || !snapshot || !fontReady || !consent.checked || snapshot.revision !== revision) return;
      busy = true;syncAdd();review.disabled = true;q('[data-set-edit]').disabled = true;
      const item = snapshot.item;
      try {
        const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
        if (!response.ok) throw new Error(data.text.error);
        location.assign(root.dataset.cartUrl);
      } catch (failure) {showError(q('[data-set-confirm-error]'),failure.message);consent.checked = false;}
      finally {busy = false;syncAdd();review.disabled = !variant?.available;q('[data-set-edit]').disabled = false;}
    });
    // No native POST may bypass spelling confirmation for set products.
    form.noValidate = true;render();
    root.__setProduct = {destroy(){abort.abort();components.forEach(c => c.preview.destroy());delete root.__setProduct;}};
  }
  document.addEventListener('DOMContentLoaded',() => document.querySelectorAll('[data-set-product]').forEach(init));
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-set-product]').forEach(init));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-set-product]').forEach(root => root.__setProduct?.destroy()));
})();
